export default __webpack_public_path__ + "static/media/logo_s.27815755.png";